import { icons, images } from 'assets/AssetHelper'

export const detailsData = ({ data }) => [
    {

    },
];


